import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
loading:boolean=false;
  constructor() { }
}
